import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import {APIProvider, InfoWindow, Map} from "@vis.gl/react-google-maps";
import addressHTML, {HTML} from "../../../components/addressHTML";
import CloseX from "../../icons/CloseX";
import Loading from "../../icons/Loading";
import MapPointers from "./MapPointers";
import dataLayerHandler from "../../../components/dataLayerHandler";


const GOOGLE_MAPS_KEY = 'AIzaSyBJ-YQe4nu2I49FsFpymJhotswIdEFfVAc';

const Stockists = (props) => {

  let autoComplete = null;

  const {
    productid,
    product,
  } = props;
  const autoCompleteRef = useRef(null);
  const enquireForm = useRef(null);
  const [mapAPIInit, setMapAPIInit] = useState(false);
  const [searched, setSearched] = useState(false);
  const [stockists, setStockists] = useState([]);
  const [results, setResults] = useState([]);
  const [completed, setCompleted] = useState(false);
  const [enquireLoading, setEnquireLoading] = useState(false);
  const [activeStockist, setActiveStockist] = useState(null);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [val, setVal] = useState(undefined);
  const [lat, setLat] = useState(undefined);
  const [lng, setLng] = useState(undefined);
  const [recenter, setReCenter] = useState(true);
  const [radius, setRadius] = useState(20);
  const [bounds, setBounds] = useState(undefined);
  const [selectedStockist, setSelectedStockist] = useState(undefined);

  const loadStockists = async () => {
    const response = await axios.get('stockists-api/stockists-feed');
    const data = response.data;
    setStockists(data);
  }

  const onPlaceChanged = () => {
    const location = autoComplete.getPlace();
    if (location && location.geometry) {
      const newLat = location.geometry.location.lat();
      const newLng = location.geometry.location.lng();

      setVal(location.formatted_address);
      setLat(newLat);
      setLng(newLng);
      const newBounds = new google.maps.LatLngBounds();
      const center = new google.maps.LatLng(newLat, newLng);
      newBounds.extend(center);
      setBounds(newBounds);
      setSearched(!searched);
    }
  };

  const checkLocationMatch = (stockist) => {
    if (lat && lng && radius) {
      if (stockist.latitude && stockist.longitude) {
        const source = new google.maps.LatLng(lat, lng);
        const dest = new google.maps.LatLng(
          parseFloat(stockist.latitude),
          parseFloat(stockist.longitude)
        )
        const d = google.maps.geometry.spherical.computeDistanceBetween(source, dest);
        return d <= radius * 1000;
      }
    }
    return true;
  }
  const checkLocationInBounds = (stockist, bounds) => {
    const dest = new google.maps.LatLng(
      parseFloat(stockist.latitude),
      parseFloat(stockist.longitude)
    )
    return bounds.contains(dest);
  }

  const handleLocationEnter = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();

      const downArrow = new KeyboardEvent('keydown', { key: 'ArrowDown', keyCode: 40, which: 40 });
      const enter = new KeyboardEvent('keydown', { key: 'Enter', keyCode: 13, which: 13 });

      autoCompleteRef.current.dispatchEvent(downArrow);
      autoCompleteRef.current.dispatchEvent(enter);
    }
  }

  const onBoundsChanged = (e) => {
    if (e.map) {
      setBounds(undefined);
      const bounds = e.map.getBounds();
      const results = [];
      stockists.map((stockist) => {
        if (stockist.latitude && stockist.longitude && checkLocationInBounds(stockist, bounds)) {
          results.push(stockist);
        }
      });
      setResults(results);
      setVal('');
    }
  }


  const onSubmit = (e) => {
    e.preventDefault();
    if (enquireLoading) {
      return false;
    }

    const data = new FormData(enquireForm.current);
    setEnquireLoading(true);
    setCompleted(false);

    fetch('stockists-api/enquire', {
      method: 'POST',
      body: data
    }).then((response) => {
      setEnquireLoading(false);
      setCompleted(true);
      enquireForm.current.reset();
      
      //Code for cnversion tracking
      dataLayerHandler('enquiry_success');
      
      setTimeout(() => {
        setPopupOpen(false);
      }, 5000);
    });
    return false;
  };

  useEffect(() => {
    setSearched(true);
  }, [radius, val])

  useEffect(() => {
    if (mapAPIInit && lat && lng) {
      const results = [];
      const b = new google.maps.LatLngBounds();
      stockists.map((stockist) => {
        if (checkLocationMatch(stockist)) {
          results.push(stockist);

          // need lat / lng to go to the map view
          if (stockist.latitude && stockist.longitude) {
            b.extend({
              lat: parseFloat(stockist.latitude),
              lng: parseFloat(stockist.longitude),
            });
          }
        }
      });
      setResults(results);
      // if (recenter) {
      setBounds(b);
      // }
    }
  }, [searched, radius, val]);

  useEffect(() => {
    if (autoCompleteRef.current) {
      autoComplete = new google.maps.places.Autocomplete(
        autoCompleteRef.current,
        {
          types: ['geocode'],
          componentRestrictions: {
            country: ['NZ']
          }
        }
      );
      autoComplete.addListener(
        'place_changed',
        onPlaceChanged
      );

    }

  }, [autoCompleteRef.current]);

  useEffect(() => {
    loadStockists();
  }, []);

  if (stockists.length === 0) {
    return null;
  }

  return <>
    <APIProvider
      apiKey={GOOGLE_MAPS_KEY}
      onLoad={() => { setMapAPIInit(true) }}
      libraries={['places', 'geometry']}
    >
      <div className="enquire-product">
        <div className="enquire-product__search">
          <div className="enquire-product__your-location">
            <div className={'form'}>
              <label>Enter your location to view distributors:</label>
              <input
                type="text"
                placeholder="Your location"
                ref={autoCompleteRef}
                value={val}
                onKeyUp={handleLocationEnter}
                onChange={(e) => {
                  setVal(e.target.value)
                }}
              />
            </div>
          </div>
          <div className="enquire-product__radius">
            <form>
              <label>Choose Radius</label>
              <select
                id="radius"
                name="radius"
                value={radius}
                onChange={(e) => { setRadius(e.target.value) }}
                className="dropdown">
                <option value="10">10 km</option>
                <option value="20">20 km</option>
                <option value="50">50 km</option>
              </select>
            </form>
          </div>
        </div>
        <div className="enquire-product__content">
          <div className="enquire-product__distributors">
            {results
              .filter((stockist) => stockist && stockist.title)
              .map((stockist, index) => (
              <div
                key={index}
                onMouseEnter={() => {
                  setActiveStockist(stockist)
                }}
                onMouseLeave={() => {
                  setActiveStockist(null);
                }}
                className="enquire-product__distributor">
                <div className="enquire-product__distributor__wrapper">
                  <h6>{stockist.title}</h6>
                  <div className="enquire-product__distributor__detail">
                    <p dangerouslySetInnerHTML={{__html: addressHTML(stockist, HTML)}} />
                    <div className="enquire-product__distributor__actions">
                      <div className="enquire-product__distributor__action">
                        <button
                          data-ge={'enquire_popup'}
                          data-name={product?.title}
                          className="btn btn--black enquire-product__distributor__contact"
                          onClick={() => {
                            setSelectedStockist(stockist);
                            setPopupOpen(true);
                          }}>Contact</button>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            ))}
          </div>
          <div className="enquire-product__map">
            <Map
              defaultZoom={6}
              defaultCenter={{
                lat: -41.972659,
                lng: 173.734425
              }}
              mapId={'stockists-map'}
              onDragStart={() => {
                setReCenter(false)
              }}
              onDragend={onBoundsChanged}
              onZoomChanged={onBoundsChanged}
            >
              <MapPointers
                setPopupOpen={setPopupOpen}
                setSelectedStockist={setSelectedStockist}
                setActiveStockist={setActiveStockist}
                activeStockist={activeStockist}
                stockists={results}
                bounds={bounds} />
            </Map>
          </div>
        </div>
      </div>
      {isPopupOpen && <div className="enquire-product__form-wrapper" id="enquire">
        <div className="enquire-product__form">

          <div className="enquire-product__form__title">
            <h2>Enquire now</h2>
            <button className="close-btn" onClick={() => { setPopupOpen(false) }}><CloseX /></button>
          </div>
          <form
            method={'post'}
            onSubmit={onSubmit}
            ref={enquireForm}>
            <div className="enquire-product__form__field">
              <label>Your name:*</label>
              <input
                name={'Name'}
                type={'text'}
                required={true} />
            </div>
            <div className="enquire-product__form__field">
              <label>Your organisation:*</label>
              <input
                name={'Organisation'}
                type={'text'}
                required={true} />
            </div>
            <div className="enquire-product__form__field">
              <label>Your postcode:*</label>
              <input
                name={'Postcode'} type={'text'} required={true} />
            </div>
            <div className="enquire-product__form__field">
              <label>Your email address:*</label>
              <input
                name={'Email'} type={'email'} required={true} />
            </div>
            <div className="enquire-product__form__field">
              <label>Your phone number:*</label>
              <input
                name={'Phone'} type={'text'} required={true} />
            </div>
            <div className="enquire-product__form__field">
              <label>Product:*</label>
              <input
                name={'Product'} type={'text'} value={product} required={true} />
              <input
                name={'ProductID'}
                type={'hidden'}
                value={productid ? productid : 0}
              />
            </div>
            <div className="enquire-product__form__field">
              <label>Quantity:*</label>
              <input
                name={'FittingOut'} type={'text'} required={true} />
            </div>
            <div className={'enquire-product__form__field enquire-product__form__field--full'}>
              <label>Embellishment:*</label>
              <ul>
                <li>
                  <input
                    type={'radio'}
                    id={'Embellishment1'}
                    value={'yes'}
                    name={'Embellishment'} />
                  <label htmlFor={'Embellishment1'}>I want a logo on these garments</label>
                </li>
                <li>
                  <input
                    type={'radio'}
                    id={'Embellishment2'}
                    name={'Embellishment'}
                    required={true} />
                  <label htmlFor={'Embellishment2'}>I want plain garments, no logo</label>
                </li>
              </ul>
            </div>
            <div className={'enquire-product__form__field '}>
              <label>Other details, eg branding requirements, colours, sizes:</label>
              <textarea
                name={'Message'} rows={3}></textarea>
            </div>
            <input type={'hidden'} name={'Stockist'} value={selectedStockist ? selectedStockist.id : 0} />

            {!!completed && <p className={'enquire-product__form__message'}>
              Thanks for your enquiry. Expect a response soon!
            </p>}

            <div className={'enquire-product__form__actions '}>
              <div className={'enquire-product__form__action'}>
                <button type={'submit'} className={'btn btn--black'}>
                  {enquireLoading ? <Loading /> : 'Enquire'}
                </button>
              </div>
              <div className={'enquire-product__form__action'}>
                <button
                  onClick={() => { setPopupOpen(false) }}
                  className={'btn btn--white'}>
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>}
    </APIProvider>
  </>

};

export default Stockists;
